.rowActionsMenu {
    align-items: center;
    display: inline-flex;
    justify-content: center;
}

.menu {
    background-color: var(--row-actions-menu-background-color);
    border-radius: var(--row-actions-menu-border-radius);
    box-shadow: var(--row-actions-menu-box-shadow);
    display: flex;
    flex-direction: column;
    min-width: var(--row-actions-menu-min-width);
    overflow: hidden;
    padding: var(--row-actions-menu-padding);
    position: fixed;
    z-index: var(--row-actions-menu-z-index);
}

.menuItem {
    color: var(--row-actions-menu-item-color);
    display: block;
    font-size: var(--row-actions-menu-item-font-size);
    padding: var(--row-actions-menu-item-padding);
    text-align: left;
    width: 100%;

    &:hover {
        background-color: var(--row-actions-menu-item-hover-background-color);
    }

    &.destructive {
        color: var(--row-actions-menu-destructive-color);
    }
}

.icon {
    display: block;
    height: var(--row-actions-menu-icon-size);
    width: var(--row-actions-menu-icon-size);
}
